import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function xz() {
    return (
        <Container className="mb-5">

        </Container>
    );
}

export default xz;